export default __webpack_public_path__ + "static/media/31g.9458832d.svg";